import { createContext, useContext } from 'react';

/**
 * Lets any page open the shell's modals (cart, auth) without prop-drilling
 * through the router. The modals live in Layout because the header opens them
 * from every route — mirroring the prototype, where they were top-level
 * modals in the document and any handler could call openCart()/openAuth().
 */
export interface UIActions {
  openCart: () => void;
  openAuth: (mode: 'login' | 'signup') => void;
  /** toast() (:726) — the prototype's confirmation bar, callable from anywhere. */
  toast: (message: string) => void;
  /** openCounsel() (:5167) — the 1:1 counselling modal, opened from several pages. */
  openCounsel: (preset?: { goal?: string; slot?: string; centreSlug?: string; centreName?: string }) => void;
  /** openDoubt() (:4300) — AskMAK doubt-solve chat for a course; login-gated. */
  openDoubt: (courseSlug: string) => void;
}

const Ctx = createContext<UIActions | null>(null);

export const UIProvider = Ctx.Provider;

export function useUI(): UIActions {
  const v = useContext(Ctx);
  if (!v) throw new Error('useUI must be used inside <UIProvider>');
  return v;
}
